import { apiClient } from './client';

// Vinculación de la cuenta del dashboard con Telegram desde el perfil.
// Contrato del backend (fase 5, PR aparte): si el endpoint aún no existe, responde 404.

export interface TelegramLinkToken {
  token: string;
  /** Enlace t.me con el token; al abrirlo en Telegram el bot vincula la cuenta. */
  deepLink: string;
  expiresAt: string;
}

export interface TelegramLinkStatus {
  linked: boolean;
  /** Teléfono enmascarado (p. ej. "+52 ••• ••• 1234") cuando está vinculado. */
  maskedPhone: string | null;
}

/** POST /api/me/telegram-link/token — genera un token de vinculación de un solo uso. */
export const createTelegramLinkToken = async (): Promise<TelegramLinkToken> =>
  (await apiClient.post('/api/me/telegram-link/token')).data;

/** GET /api/me/telegram-link/status?token=... — consulta si el token ya fue usado en Telegram. */
export const fetchTelegramLinkStatus = async (token: string): Promise<TelegramLinkStatus> =>
  (await apiClient.get('/api/me/telegram-link/status', { params: { token } })).data;

/** DELETE /api/me/telegram-link — desvincula Telegram de la cuenta. */
export const unlinkTelegram = async (): Promise<{ linked: false }> =>
  (await apiClient.delete('/api/me/telegram-link')).data;
